import { orderBy } from "lodash";
import PropTypes from "prop-types";
import React from "react";

import config from "../config";
import { ALERT_MANAGEMENT_ALERT_TYPES } from "../lib/notifications/alertManagementChannels";
import { getAlertSettingsCategoryPosition } from "../lib/notifications/alertSettingsCategoryPositions";
import getSubscriptionEnabledForChannels from "../lib/notifications/getSubscriptionEnabledForChannels";

export default class AlertManagementSwitchersAbstract extends React.Component {
  static propTypes = {
    data: PropTypes.object,
    onElementChange: PropTypes.func,
    disabled: PropTypes.bool,
    stockId: PropTypes.number,
    alertCategories: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        key: PropTypes.string
      })
    ),
    alertTypes: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        channels: PropTypes.arrayOf(PropTypes.string)
      })
    ),
    additionalSettingsCategories: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        key: PropTypes.string
      })
    )
  };

  static defaultProps = {
    alertCategories: config.alertCategories,
    alertTypes: ALERT_MANAGEMENT_ALERT_TYPES,
    generalSettingsCategories: [
      {
        name: "Webinars",
        key: "webinar"
      },
      {
        name: "Education events",
        key: "education_event"
      },
      {
        name: "Special offers",
        key: "special_offer"
      },
      {
        name: "Third party offerings",
        key: "third_party_offering"
      }
    ],
    additionalSettingsCategories: []
  };

  state = {
    processedElements: []
  };

  static getDerivedStateFromProps(props, state) {
    const { data, alertTypes, stockId } = props;

    const alertCategories = AlertManagementSwitchersAbstract.getAlertCategories(
      props
    );

    if (!data) {
      return state;
    }

    const shouldUseSpecificData = typeof stockId !== "undefined";

    const dataToUse = shouldUseSpecificData ? data.specific : data.global;

    let processedElements = [
      [
        {
          type: "description",
          value: " "
        },
        ...alertTypes.map(alertType => ({
          type: "description",
          value: alertType.name
        }))
      ]
    ];

    alertCategories.forEach(category => {
      let processedElement = [
        {
          type: "description",
          value: category.name,
          category: category.key
        }
      ];

      alertTypes.forEach(alertType => {
        const value = getSubscriptionEnabledForChannels({
          subscriptions: dataToUse,
          type: category.key,
          channels: alertType.channels,
          defaultEnabled: category.notificationsEnabledByDefault
        });

        let disabled = false;

        if (
          alertType.channels[0] !== null &&
          processedElement[1].value === false
        ) {
          disabled = true;
        }

        processedElement.push({
          type: "switcher",
          value,
          disabled,
          category: category.key,
          label: alertType.name,
          channels: alertType.channels
        });
      });

      processedElements.push(processedElement);
    });

    if (shouldUseSpecificData && data.global) {
      data.global.forEach(element => {
        if (element.status === false) {
          let row = processedElements.findIndex(
            item => item[1].category === element.type
          );

          if (row !== -1) {
            let col = processedElements[row].findIndex(
              item =>
                item.channels && item.channels.indexOf(element.channel) !== -1
            );

            processedElements[row][col].globallyDisabled = true;

            if (element.channel === null) {
              let cols = processedElements[row].map((element, index) => index);
              cols.shift();

              cols.forEach(col => {
                processedElements[row][col].disabled = true;
              });
            }
          }
        }
      });
    }

    return {
      ...state,
      processedElements
    };
  }

  static getAlertCategories(props) {
    const {
      alertCategories,
      isGeneralSettings,
      generalSettingsCategories,
      additionalSettingsCategories
    } = props;

    let categories = alertCategories;

    if (isGeneralSettings) {
      categories = [...categories, ...generalSettingsCategories];
    }

    const mergedCategories = AlertManagementSwitchersAbstract.attachNotificationEnabledByDefaultToCategories(
      [...additionalSettingsCategories, ...categories]
    );

    const seenKeys = new Set();
    const uniqueCategories = orderBy(
      mergedCategories,
      ({ position }) => position ?? 0
    ).filter(({ key }) => {
      if (seenKeys.has(key)) {
        return false;
      }

      seenKeys.add(key);
      return true;
    });

    return uniqueCategories;
  }

  static attachNotificationEnabledByDefaultToCategories(categories) {
    return categories.map(category => {
      return {
        ...category,
        position: getAlertSettingsCategoryPosition(category.key),
        notificationsEnabledByDefault:
          typeof category.notificationsEnabledByDefault === "undefined"
            ? true
            : category.notificationsEnabledByDefault
      };
    });
  }
}
